/* eslint-disable react/prop-types -- this codebase does not use propTypes (see CLAUDE.md). */
// Small building blocks for the Marketing page, in the redesign's tokens
// (rounded-[14px] cards on gray-200 borders, 44px controls, indigo accent).
import {
  BellIcon,
  ChatBubbleLeftIcon,
  EnvelopeIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

export function Pill({ className = "bg-gray-100 text-gray-800", children }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${className}`}
    >
      {children}
    </span>
  );
}

const CHANNEL_ICONS = {
  push: BellIcon,
  email: EnvelopeIcon,
  sms: ChatBubbleLeftIcon,
};

export function ChannelIcon({ type, className = "" }) {
  const Icon = CHANNEL_ICONS[type] || BellIcon;
  return (
    <span
      aria-hidden="true"
      className={`flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-[9px] bg-indigo-50 text-indigo-800 ${className}`}
    >
      <Icon className="h-4 w-4" />
    </span>
  );
}

export function CloseButton({ onClick, label }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200"
    >
      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}
